import { useCallback } from 'react'

const sortFilterMap = {
  'most recently added': 'createdAt:desc',
  'oldest added': 'createdAt:asc',
  'title (a–z)': 'title:asc',
  'title (z–a)': 'title:desc'
}

const timeRangeMap = {
  '0-5 mins': [0, 5],
  '5-15 mins': [5, 15],
  '15-30 mins': [15, 30],
  '30+ mins': [30, 999]
}

const useEventFilters = () => {
  const getEventFilters = useCallback(
    ({ type, sort, contentType, start, subcat, time, ...rest }) => {
      const eventSort = sortFilterMap[sort?.toLowerCase()] || ''
      const eventTime = timeRangeMap[time] || undefined
      return { types: type, sort: eventSort, ...(eventTime && { time: eventTime }), ...rest }
    },
    []
  )

  return { getEventFilters }
}

export default useEventFilters
